// Color generator http://scg.ar-ch.org/
// Calc: {
//   base: from Standards Bootstrap,
//   lighten5: base at 0.12 opacity to match alerts calculated background
//             calculate HEX from rbga - https://tdekoning.github.io/rgba-converter/
//   lighten4: .30,
//   lighten3: .47,
//   lighten2: .67,
//   lighten1: .82,
//   darken1: "#005289",
//   darken2: "#003456",
//   darken3: "#001523",
// }

export const mainColors = {
  primary: {
    lighten5: '#e0f3ff', // lighten 57% to ensure enough contrast with base
    lighten4: '#93d4ff', // 42%
    lighten3: '#4cb8ff', // 28%
    lighten2: '#049bff', // 14%
    lighten1: '#007acb', // lighten 3% to ensure enough contrast
    base: '#0071bc', // Rgb(0, 113, 188)
    darken1: '#005289',
    darken2: '#003456',
    darken3: '#001523',
  },
  accent: {
    lighten5: '#e0ebf2',
    lighten4: '#b2cddf',
    lighten3: '#87b0cd',
    lighten2: '#548fb7',
    lighten1: '#2d76a8',
    base: '#005995', // Rgb(0, 89, 149)
    darken1: '#003b62',
    darken2: '#001c2f',
  },
}

export const grayscaleColors = {
  secondary: {
    lighten5: '#F3F3F4',
    lighten4: '#D9D9DC',
    lighten3: '#C0C0C5',
    lighten2: '#95959C',
    lighten1: '#76767E',
    base: '#595961',
    darken1: '#3C3C43',
    darken2: '#202024',
  },
}

export const contextualColors = {
  success: {
    lighten5: '#e6f0e5',
    lighten4: '#c1dabf',
    lighten3: '#9ec59b',
    lighten2: '#75ad70',
    lighten1: '#569a51',
    base: '#32852b', // Rgb(50, 133, 43)
    darken1: '#266621',
    darken2: '#1b4717',
    darken3: '#0f280d',
  },
  info: {
    lighten5: '#e8f5ff',
    lighten4: '#c5e7ff',
    lighten3: '#a5daff',
    lighten2: '#7fcbff',
    lighten1: '#62bfff',
    base: '#40b2ff', // Rgb(64, 178, 255)
    darken1: '#008eed',
    darken2: '#005d9c',
    darken3: '#002c4a',
  },
  warning: {
    lighten5: '#fef8e4',
    lighten4: '#feedbb',
    lighten3: '#fde395',
    lighten2: '#fcd868',
    lighten1: '#fccf46',
    base: '#fcc51e', // Rgb(252, 197, 30)
    darken1: '#d09d03',
    darken2: '#896802',
    darken3: '#433301',
  },
  error: {
    lighten5: '#f8e5e5',
    lighten4: '#eebfbe',
    lighten3: '#e49a99',
    lighten2: '#d9706e',
    lighten1: '#d1504e',
    base: '#c72a28', // Rgb(199, 42, 40)
    darken1: '#9d211f',
    darken2: '#721817',
    darken3: '#480f0e',
  },
}

export const graphColors = {
  // Graph Colors
  blue: {
    base: '#388fc9',
    darken1: '#27658e',
  },
  red: {
    base: '#ef3c39',
    darken1: '#cb1310',
  },
  yellow: {
    base: '#ffdf7f',
    darken1: '#ffcc33',
  },
  green: {
    base: '#6dc065',
    darken1: '#479a3f',
  },
  orange: {
    base: '#ea9423',
    darken1: '#b06b11',
  },
  purple: {
    base: '#a967aa',
    darken1: '#7d467e',
  },
  gray: {
    base: '#8a8c8e',
    darken1: '#646668',
  },
}

export const tenStopGraphColors = {
  graph: {
    base: '#388fc9',
    lighten1: '#6c7ec0',
    lighten2: '#a967aa',
    lighten3: '#c85385',
    lighten4: '#df415b',
    lighten5: '#ef3c39',
    lighten6: '#ef6223',
    lighten7: '#ea9423',
    lighten8: '#f5bf50',
    lighten9: '#ffdf7f',
  },
}

export const heatMapColors = {
  yellowGradient: {
    base: '#fccf46',
    lighten1: '#fcd458',
    lighten2: '#fcd869',
    lighten3: '#fddd7b',
    lighten4: '#fde18c',
    lighten5: '#fde69e',
    lighten6: '#fdeaaf',
    lighten7: '#feefc1',
    lighten8: '#fef3d2',
    lighten9: '#fef8e4',
  },
  blueGradient: {
    base: '#0099ff',
    lighten1: '#32a4f1',
    lighten2: '#3ba9f1',
    lighten3: '#4db0f3',
    lighten4: '#67bcf5',
    lighten5: '#81c7f7',
    lighten6: '#9bd3f9',
    lighten7: '#b4defb',
    lighten8: '#ceeafd',
    lighten9: '#e8f5ff',
  },
  divergingGradient: {
    base: '#81c7f7',
    lighten1: '#a0d3f2',
    lighten2: '#c0e0ee',
    lighten3: '#dfece9',
    lighten4: '#fef8e4',
    lighten5: '#f5d6c6',
    lighten6: '#ecb5a8',
    lighten7: '#e6a098',
    lighten8: '#e18d89',
    lighten9: '#dc7b79',
  },
}

export default {
  ...mainColors,
  ...grayscaleColors,
  ...contextualColors,
  ...graphColors,
  ...tenStopGraphColors,
  ...heatMapColors,
}
